/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель для скидки в корзине.
   */
  app.Discount = app.Model.extend({
    getCurrent: function () {
      var currentState = this.get('accumulateSum') || this.get('accumulateQty');
      return currentState ? currentState : 0;
    },
    getPercent: function () {
      var start = this.getStart(),
        all = this.getEnd() - start,
        current = this.getCurrent() - start;
      return (current / all) * 100;
    },
    getStart: function () {
      var currentStep = this.get('currentStep');
      if (currentStep) {
        return currentStep.sum_range ? currentStep.sum_range.from : currentStep.qty_range.from;
      }
      return 0;
    },
    getEnd: function () {
      var currentStep = this.get('currentStep');
      if (currentStep) {
        return currentStep.sum_range ? currentStep.sum_range.to : currentStep.qty_range.to;
      }
      return 0;
    },
    getRest: function () {
      var end = this.getEnd(),
        current = this.getCurrent();
      return app.helpers.NumberHelper.roundFloatPointNum(end - current);
    }
  });
})();

}.call(window));